module.exports = __webpack_public_path__ + "media/לחמנייה.0a11ad57.mp3";